//@ts-nocheck

import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import Link from "next/link";
import CallToActionButton from "components/shared/buttons/CallToActionButton";
import ApiStory from "models/data/api/ApiStory";
import gql from "graphql-tag";
import { ApolloConsumer, Query } from "react-apollo";
import { getStorySlug } from "data/api/ApiStory";
import useFirebaseSession from "hooks/useFirebaseSession";
import {
  CtaType,
  useRecordCtaClicked,
} from "hooks/analytics/useRecordCtaClicked";
import { baseUrl } from "services/shared/Environment";
import { trackResubscribeClickOnStoryPaywall } from "services/browser/Analytics";

const Gradient = styled.div.attrs((props: any) => ({
  className: `h-full w-full absolute`,
}))<any>`
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    hsl(0, 0%, 100%) 100%
  );
`;

const PaywallCard = styled.div.attrs({
  className:
    "flex flex-col items-center justify-center p-6 rounded-lg w-5/6 mx-auto left-0 right-0",
})`
  position: fixed;
  width: 100%;
  bottom: 0px;
  border-radius: 0px;
  background-color: black;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  color: white;
`;

const PaywallMessage = styled.h2.attrs({
  className: "text-lg lg:text-xl mb-8 text-center",
})`
  color: white;
  font-family: ${(props) => props.theme.fonts.poppins};
  font-weight: 400;
  max-width: 500px;
`;

const SignupButton = styled<any>(CallToActionButton)`
  width: 100%;
  font-size: 16px;
  max-width: 500px;
`;

const LoginButton = styled<any>(CallToActionButton)`
  width: 100%;
  max-width: 500px;
  font-size: 16px;
  text-transform: none;
  border: 1px solid black;
  color: white;
  background-color: rgba(0, 0, 0, 0);
  margin-top: 10px;
  :hover {
    background-color: white;
    color: black;
    border: 1px solid white;
  }
`;
const getUserDetails = gql`
  query userQuery($firebaseId: ID!) {
    user(firebaseId: $firebaseId) {
      id
      subscriptionHasExpired
    }
  }
`;

const PayWall = ({ story }) => {
  const { loggedInUserId, sessionInitialized, userIsLoggedIn } =
    useFirebaseSession();

  const paywallMessageRef = useRef(null);
  const paywallMessageElement = paywallMessageRef?.current;
  const elementInnerHtml = paywallMessageElement?.innerHTML;

  const isServer = !(typeof window != "undefined" && window.document);

  useEffect(() => {
    if (paywallMessageElement && elementInnerHtml) {
      const paywallMessage =
        "Read this article and many more by subscribing today. We're like your other favorite publications — but Browner.";
      if (elementInnerHtml !== paywallMessage) {
        paywallMessageRef.current.innerHTML = paywallMessage;
      }
    }
  }, [paywallMessageElement, elementInnerHtml]);

  const startYourFreeTrialButtonText = "Try for free ➔";
  const startYourFreeTrialHrefPath = "subscribe";

  const recordStartYourFreeTrialButtonClicked = useRecordCtaClicked();
  const recordAlreadyASubscriberButtonClicked = useRecordCtaClicked();

  return (
    <Query query={getUserDetails} variables={{ firebaseId: loggedInUserId }}>
      {({ loading, error, data }) => {
        if (loading || error) return <div />;

        return (
          <Gradient>
            <PaywallCard
              id={isServer ? "paywall-server" : "paywall"}
              data-analytics-id="paywall"
            >
              <PaywallMessage ref={paywallMessageRef}>
                Read this article and many more by subscribing today. We're like
                your other favorite publications — but Browner.
              </PaywallMessage>
              {sessionInitialized &&
                userIsLoggedIn &&
                data.user.subscriptionHasExpired && (
                  <Link
                    href={{
                      pathname: "settings",
                      query: { fromStoryWithSlug: getStorySlug(story) },
                    }}
                  >
                    <SignupButton
                      onClick={() =>
                        trackResubscribeClickOnStoryPaywall(ApiStory.id(story))
                      }
                    >
                      Restart your subscription
                    </SignupButton>
                  </Link>
                )}

              {sessionInitialized && !userIsLoggedIn && (
                <Link
                  href={{
                    pathname: startYourFreeTrialHrefPath,
                    query: { fromStoryWithSlug: getStorySlug(story) },
                  }}
                >
                  <SignupButton
                    onClick={() => {
                      recordStartYourFreeTrialButtonClicked({
                        ctaType: CtaType.button,
                        ctaText: startYourFreeTrialButtonText,
                        ctaDestinationUrl: `${baseUrl()}/${startYourFreeTrialHrefPath}`,
                      });
                    }}
                  >
                    {startYourFreeTrialButtonText}
                  </SignupButton>
                </Link>
              )}

              {data.firebaseUserId ? null : (
                <Link
                  href={{
                    pathname: "login",
                    query: { fromStoryWithSlug: getStorySlug(story) },
                  }}
                >
                  <LoginButton
                    onClick={() => {
                      recordAlreadyASubscriberButtonClicked({
                        ctaType: "button",
                        ctaText: "Already a subscriber? Sign in",
                        ctaDestinationUrl: `${baseUrl()}/login`,
                      });
                    }}
                  >
                    <span className="mr-2">
                      Already a subscriber? <b>Sign in</b>
                    </span>
                  </LoginButton>
                </Link>
              )}
            </PaywallCard>
          </Gradient>
        );
      }}
    </Query>
  );
};
export default (props) => (
  <ApolloConsumer>
    {(apolloClient) => <PayWall apolloClient={apolloClient} {...props} />}
  </ApolloConsumer>
);
